// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3_axl","validationTips":"StatementDescriptor_validationTips__1MP8y"};